import BaseModel from './BaseModel'

export default class AccessoryBin extends BaseModel {
  // ... AccessoryBin-specific methods or overrides ...
}
